import { createApp } from 'vue'

import { SearchPanelWelcome as SearchPanelWelcomeApp } from '@/modules/search_panel/desktop'

window.onload = function initWelcomeSearchBarApp() {
  const welcomeSearchBarApp = createApp(SearchPanelWelcomeApp)
  welcomeSearchBarApp.mount('#welcome-search-bar-app')
}
